<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-header-actions">

                          <div class="col-12 card-header-filter-box">
                            <div class="row align-items-end">
                              <div class="col-12 col-sm-4 card-header-search-box">
                                <div class="input-group">
                                    <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search" @keypress.enter="initList">
                                    <div class="input-group-append">
                                        <button class="all-btn search-btn" @click="initList">
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                              </div>
                              <div class="col-12 col-sm-3 card-header-select-box mt-2 mt-sm-0">
                                <div>
                                  <label>Кадастр рақами</label>
                                  <cadastre-input :cadastre-number.sync="filter.cadastreDocNumber"/>
                                </div>
                              </div>
                              <div class="col-12 col-sm-3 card-header-select-box mt-2 mt-sm-0">
                                <div class="form-group">
                                  <label class="text-gray">{{$t("main.searchStatus")}}</label>
                                  <div class="position-relative">
                                    <select class="form-control"
                                            v-model="filter.status"
                                            @change="onChangeStatus">
                                      <option value=""></option>
                                      <option value="Pending">{{$t("realEstate.status.pending")}}</option>
                                      <option value="AssignedToEvaluator">{{$t("realEstate.status.assignedToEvaluator")}}</option>
                                      <option value="NotFullyEvaluated">{{$t("realEstate.status.notFullyEvaluated")}}</option>
                                      <option value="Evaluated">{{$t("realEstate.status.evaluated")}}</option>
                                      <option value="Confirmed">{{$t("realEstate.status.confirmed")}}</option>
                                      <option value="Rejected">{{$t("realEstate.status.rejected")}}</option>
                                      <option value="SentToComplement">{{$t("realEstate.status.sentToComplement")}}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 col-sm-2 card-header-select-box">
                                <div class="form-group">
                                  <label>{{$t("action.province")}}</label>
                                  <v-select
                                          label="name"
                                          v-model="province"
                                          :filterable="false"
                                          :options="provinces"
                                          @search="onProvinceSearch"
                                          @search:focus="onProvinceFocus"
                                          @change="onChangeFilterProvince"
                                  >
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                  </v-select>
                                </div>
                              </div>
                              <div class="col-12 col-sm-2 card-header-select-box">
                                <div class="form-group">
                                  <label>{{$t("action.region")}}</label>
                                  <v-select
                                          label="name"
                                          v-model="region"
                                          :filterable="false"
                                          :options="regions"
                                          @search="onRegionSearch"
                                          @search:focus="onRegionFocus"
                                          @change="onChangeFilterRegion"
                                  >
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                            <label class="mr-3 mt-3" v-if="results && results.total">Жами: {{results.total}}</label>
                            <router-link tag="button" class="all-btn add-btn m-0" :to="addRealEstateUrl" v-if="hasPermission('NEW_REAL_ESTATE_ADD')">
                              {{$t("action.add")}}
                            </router-link>
                            <!--<router-link tag="button" class="all-btn pull-right mr-3" :to="'/new-real-estate/cadastre-api/test'">-->
                            <!--Кадастр АПИни текшириш-->
                            <!--</router-link>-->
                          </div>
                        </div>
                    </div>
                    <div class="card-body table-responsive">
                        <div class="table-wrapper">
                          <table class="table table-hover">
                            <thead>
                            <tr>
                              <th>#</th>
                              <th>{{$t("realEstate.field.name")}}</th>
                              <th>{{$t("realEstate.field.area")}}</th>
                              <th class="text-center">Ёндашувлар</th>
                              <th>Алоҳида қулайликлар</th>
                              <th class="text-center">Илова хужжатлари</th>
                              <th class="text-center">{{$t("realEstate.field.status")}}</th>
                              <th>Шахслар</th>
                              <th>Бахоловчи</th>
                              <th>Директор</th>
                              <th class="text-center" v-if="hasPermission('NEW_REAL_ESTATE_VIEW') || hasPermission('NEW_REAL_ESTATE_EDIT')">
                                {{$t("realEstate.field.action")}}
                              </th>
                            </tr>
                            </thead>
                            <tbody v-if="!loading && results && results.data">
                            <tr v-for="result in results.data" :key="result.id">
                              <td class="text-center">
                                <div>{{result.id}}</div>
                                <div><b>{{getGoalType(result.evlGoalType)}}</b></div>
                                <div v-if="result.source === 'INSIDE'" class="badge badge-info">{{$t("realEstate.createType.ourselves")}}</div>
                                <div v-if="result.source === 'ONLINE'" class="badge badge-secondary">{{$t("realEstate.createType.online")}}</div>
                                <div v-if="result.source === 'API_MIB'" class="badge badge-warning">{{$t("realEstate.createType.apiMib")}}</div>
                                <div v-if="result.source === 'ANDROID'" class="badge badge-warning">{{$t("realEstate.createType.android")}}</div>
                                <div v-if="result.source === 'API_BANK'" class="badge badge-warning">{{$t("realEstate.createType.api_bank")}}</div>
                                <div v-if="result.source === 'EXPERT2'" class="badge badge-primary">{{$t("realEstate.createType.expert2")}}</div>
                                <div v-if="result.source === 'API_EXARID'" class="badge badge-warning">{{$t("realEstate.createType.api_exarid")}}</div>
                                <span v-if="result.orderId" class="text-secondary font-weight-bold">#{{result.orderId}}</span>
                                <span v-if="result.expert2Id" class="text-secondary font-weight-bold">#{{result.expert2Id}}</span>
                              </td>
                              <td width="15%">
                                <div class="font-weight-bold">{{result.name}}</div>
                                <div class="text-success" v-if="result.province">
                                  <span>{{result.province.name}},</span>
                                </div>
                                <div class="text-success" v-if="result.region">
                                  <span>{{result.region.name}}, </span>
                                </div>
                                <div class="text-success">
                                  <span>{{result.address}} </span>
                                </div>
                                <div v-if="result.evlAmountToPay && result.evlAmountToPay > 0" class="font-italic">
                                  <div v-if="result.evlTaxPercent > 0">
                                    Контракт суммаси + НДС({{result.evlTaxPercent | currency('', 0, { thousandsSeparator: ' ' })}}%): {{result.evlAmountToPay | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                                  </div>
                                  <div v-else>
                                    Контракт суммаси: {{result.evlAmountToPay | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                                  </div>
                                  Тўланган сумма: {{result.paidAmount | currency('', 0, { thousandsSeparator: ' ' })}} сўм<br/>
                                  <div class="badge badge-success" v-if="result.paidAmount >= result.evlAmountToPay">Тўланган</div>
                                  <div class="badge badge-warning" v-else-if="result.paidAmount > 0">Қисман тўланган</div>
                                  <div class="badge badge-danger" v-else>Тўланмаган</div>
                                </div>
                              </td>
                              <td width="30%">
                                <template>
                                  <div>
                                    Умумий ер майдони (кв.м):
                                    <span class="text-secondary font-weight-bold">{{result.evlGroundArea}}</span>
                                  </div>
                                  <div>1 кв.м нархи</div>
                                  <div class="font-weight-bold" v-if="result.landComparisonEnabled && result.newLandComparison && result.newLandComparison.totalPrice > 0">
                                    {{result.newLandComparison.totalPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                  </div>
                                  <div class="font-weight-bold" v-else-if="result.landLeaseEnabled && result.landLeaseData && result.landLeaseData.rentAmount > 0">
                                    {{result.landLeaseData.rentAmount | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                  </div>
                                  <div v-else class="text-secondary font-weight-bold">0.0</div>
                                  <div class="form-group" v-if="canSave(result)">
                                    <div class="form-check checkbox-inline">
                                      <label class="form-check-label pl-0">
                                        <input class="form-check-input" type="checkbox"
                                               v-model="result.landComparisonEnabled"
                                               name="landComparisonEnabled"
                                               @change="handleChangeLand($event, result)"
                                        >
                                        <span class="form-check-sign"></span>
                                        Ердан фойдаланиш
                                      </label>
                                    </div>
                                    <div class="form-check checkbox-inline">
                                      <label class="form-check-label pl-0">
                                        <input class="form-check-input" type="checkbox"
                                               v-model="result.landLeaseEnabled"
                                               name="landLeaseEnabled"
                                               @change="handleChangeLand($event, result)"
                                        >
                                        <span class="form-check-sign"></span>
                                        Ер ижара булганда
                                      </label>
                                    </div>
                                  </div>
                                  <div>
                                    Фойдали майдони (кв.м):
                                    <span class="font-weight-bold">{{result.evlUsefulField}}</span>
                                  </div>
                                  <div>1 кв.м нархи</div>
                                  <div class="font-weight-bold" v-if="result.newComparison && result.newComparison.totalPrice > 0">
                                    {{result.newComparison.totalPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                  </div>
                                  <div v-else class="text-secondary font-weight-bold">0.0</div>
                                </template>
                              </td>
                              <td width="15%" class="text-center">
                                <template>
                                  <div v-if="result.approachCost">
                                    {{$t("realEstate.approach.expense")}}
                                    <br>
                                    <span class="font-weight-bold text-gray" v-if="result.coordination && result.coordination.expense && result.coordination.expense">
                                                {{calculateCoordination(result).expense.amount | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                            </span>
                                  </div>
                                  <div v-if="result.approachIncome">
                                    {{$t("realEstate.approach.income")}}
                                    <br>
                                    <span class="font-weight-bold text-gray" v-if="result.coordination && result.coordination.expense && result.coordination.expense">
                                                {{calculateCoordination(result).income.amount | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                            </span>
                                  </div>
                                  <div v-if="result.approachComparative">
                                    {{$t("realEstate.approach.comparative")}}
                                    <br>
                                    <span class="font-weight-bold text-gray" v-if="result.coordination && result.coordination.expense && result.coordination.expense">
                                                {{calculateCoordination(result).comparison.amount | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                            </span>
                                  </div>
                                  <div v-if="result.coordination">
                                    Мувофиқлаштириш
                                    <br>
                                    <span class="font-weight-bold text-gray">
                                                {{calculateCoordination(result).total | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                            </span>
                                  </div>
                                </template>
                              </td>
                              <td>
                                <div>{{$t("realEstate.field.architecturalStyle")}}: </div>
                                <div v-if="result.architecturalStyleDto" class="badge badge-info">{{result.architecturalStyleDto.displayName}}</div>
                                <div>{{$t("realEstate.field.specialComfort")}}: </div>
                                <div v-if="result.specialComfortDto" class="badge badge-info">{{result.specialComfortDto.displayName}}</div>
                                <div>{{$t("realEstate.field.repairConditions")}}: </div>
                                <div v-if="result.repairConditionDto" class="badge badge-info">{{result.repairConditionDto.displayName}}</div>
                                <div>{{$t("realEstate.field.constructionCompletion")}}: <span class="badge badge-info">{{result.constructionCompletion}}</span></div>
                              </td>
                              <td class="text-center">
                                <button class="all-btn add-btn btn-sm"
                                        v-if="hasPermission('NEW_REAL_ESTATE_EDIT')"
                                        v-tooltip="'Кўчмас мулкни ўзгартириш'"
                                        @click="viewRealEstateAct(result.id)"
                                >
                                  <i class="fa fa-table"></i>
                                  <span>Акт</span>
                                </button>
                                <button class="all-btn view-btn btn-sm"
                                        v-if="result.surveyData"
                                        @click="viewRealEstateSurvey(result)"
                                >
                                  <i class="fa fa-list"></i>
                                  <span>Сўровнома</span>
                                </button>
                              </td>
                              <td class="text-center">
                                <div class="badge badge-secondary" v-if="result.status==='AssignedToEvaluator'">{{$t("realEstate.status.assignedToEvaluator")}}</div>
                                <div class="badge badge-warning" v-else-if="result.status==='NotFullyEvaluated'">{{$t("realEstate.status.notFullyEvaluated")}}</div>
                                <div class="badge badge-info" v-else-if="result.status==='Evaluated'">{{$t("realEstate.status.evaluated")}}</div>
                                <div class="badge badge-success" v-else-if="result.status==='Confirmed'">{{$t("realEstate.status.confirmed")}}</div>
                                <div class="badge badge-danger" v-else-if="result.status==='Rejected'">{{$t("realEstate.status.rejected")}}</div>
                                <div class="badge badge-danger" v-else-if="result.status==='InIdentification'">{{$t("realEstate.status.inIdentification")}}</div>
                                <div class="badge badge-danger" v-else-if="result.status==='Pending'">{{$t("realEstate.status.pending")}}</div>
                                <div class="badge badge-danger" v-else-if="result.status==='SentToComplement'">{{$t("realEstate.status.sentToComplement")}}</div>
                                <div class="badge badge-danger" v-else-if="result.status ==='ErrorInPrice'">{{$t("realEstate.status.errorInPrice")}}</div>
                                <div class="text-info" v-if="result.confirmedDate && result.status==='Confirmed'">{{result.confirmedDate}}</div>
                                <div class="text-info" v-if="result.assignedToEvaluatorDate && (result.status==='NotFullyEvaluated' || result.status==='AssignedToEvaluator')">
                                  {{result.assignedToEvaluatorDate}}
                                </div>
                                <div>Бинолар сони: <span class="badge badge-info">{{result.buildings && result.buildings.length}}</span></div>
                                <div>
                                  <span class="font-weight-bold text-gray">{{result.spendTime}}</span>
                                </div>
                              </td>
                              <td width="20%">
                                <div v-if="result.owner">
                                  <span class="font-weight-bold">Мулк эгаси: </span>
                                  <span class="text-secondary">{{result.owner.fullName}}</span>
                                  <div class="text-warning">{{result.owner.firmName}}</div>
                                </div>
                                <div v-if="result.hasCustomer">
                                  <span class="font-weight-bold">Буюртмачи(ишончнома): </span>
                                  <span class="text-secondary">{{result.customer.fullName}}</span>
                                </div>
                                <template v-if="result.createdBy">
                                  <div>
                                    <span class="font-weight-bold">Бахоловчи ёрдамчиси: </span>
                                    <span class="text-secondary">{{result.createdBy.name}}</span>
                                  </div>
                                  <div class="text-info">{{result.createdBy.address}}</div>
                                </template>
                                <div v-if="result.employee">
                                  <span class="font-weight-bold">Бохоловчи: </span>
                                  <span class="text-secondary">{{result.employee.name}}</span>
                                </div>
                              </td>
                              <td>
                                <button class="all-btn add-btn btn-sm"
                                        @click="changeStatus('Evaluated',result)"
                                        v-if="result.status === 'NotFullyEvaluated' && hasPermission('REAL_ESTATE_EVALUATE')"
                                        :disabled="loadEspAppraiser"
                                >
                                  {{$t("realEstate.action.confirm")}}
                                </button>
                                <div class="text-success" v-if="result.appraiserReportEsp">
                                  <b>{{$t("realEstate.field.evaluatorEspConfirmed")}}</b>
                                </div>
                              </td>
                              <td>
                                <button class="all-btn add-btn btn-sm"
                                        @click="changeStatus('Confirmed',result)"
                                        v-if="hasPermission('REAL_ESTATE_CONFIRM') && (result.status === 'Evaluated' || (result.status === 'Confirmed' && !result.directorReportEsp))"
                                        :disabled="loadEspDirector"
                                >
                                  {{$t("realEstate.action.confirm")}}
                                </button>
                                <div class="text-success" v-if="result.directorReportEsp">
                                  <b>{{$t("realEstate.field.directorEspConfirmed")}}</b>
                                </div>
                              </td>
                              <td class="td-actions text-center">
                                <router-link :to="'/new-real-estate/view/' + result.id"
                                             v-tooltip="'Кўчмас мулк деталлари'"
                                             class="all-btn view-btn table-action"
                                             v-if="hasPermission('NEW_REAL_ESTATE_VIEW')">
                                  <i class="fa fa-image"></i>
                                </router-link>
                                <router-link :to="'/new-real-estate/edit/' + result.id"
                                             v-tooltip="'Кўчмас мулкни ўзгартириш'"
                                             class="all-btn edit-btn table-action"
                                             v-if="hasPermission('NEW_REAL_ESTATE_EDIT')">
                                  <i class="fa fa-edit"></i>
                                </router-link>
                                <!--                                    <button class="all-btn view-btn table-action"-->
                                <!--                                            v-tooltip="'Тўлов қўшиш'">-->
                                <!--                                        <i class="fa fa-credit-card"></i>-->
                                <!--                                    </button>-->
                                <button class="all-btn delete-btn table-action"
                                        v-if="(result.status !== 'Evaluated' && result.status !== 'Confirmed') && hasPermission('NEW_REAL_ESTATE_DELETE')"
                                        v-tooltip="'Кўчмас мулкни ўчириш'"
                                        @click="deletedRealEstate(result.id)"
                                >
                                  <i class="fa fa-remove"></i>
                                </button>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <NewRealEstateActModal></NewRealEstateActModal>
        <AppraiserEspModal></AppraiserEspModal>
        <DirectorEspModal></DirectorEspModal>
        <NewRealEstateSurveyModal></NewRealEstateSurveyModal>
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import {EVL_GOAL_TYPES, EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
    import NewRealEstateActModal from '@/views/real-estate/new/NewRealEstateActModal'
    import AppraiserEspModal from '@/views/real-estate/new/NewRealEstateAppraiserReportEspModal'
    import DirectorEspModal from '@/views/real-estate/new/NewRealEstateDirectorReportEspModal'
    import NewRealEstateSurveyModal from '@/views/real-estate/new/NewRealEstateSurveyModal'
    import CadastreInput from "@/components/CadastreInput.vue";

    export default {
        name: "NewRealEstateList",
        components: {
          CadastreInput,
            'b-pagination': bPagination,
            NewRealEstateActModal,
            AppraiserEspModal,
            DirectorEspModal,
            NewRealEstateSurveyModal
        },
        data() {
            return {
                loading: false,
                loadEspAppraiser: false,
                loadEspDirector: false,
                filter: {
                  ...initFilterModel(),
                  cadastreDocNumber: null
                },
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                results: null,
                goalTypes: EVL_GOAL_TYPES,
                propertyTypes: EVL_PROPERTY_TYPES,
                specialComfort: null,
                specialComforts: [],
                architecturalStyles: [],
                repairConditions: [],
                provinces: [],
                regions: [],
                province: null,
                region: null,
            }
        },
        computed: {
            addRealEstateUrl() {
                if (this.$route.meta && this.$route.meta.category && this.$route.meta.category === 'Residential') {
                    return '/new-real-estate/residential/new';
                } else {
                    return '/new-real-estate/notorious/new';
                }
            }
        },
        methods: {
            initList() {
                this.loading = true;
                if (this.$route.meta && this.$route.meta.category) {
                    this.filter.category = this.$route.meta.category;
                }
                // if (this.filter.search.length > 0) this.filter.page.page = 1;
                this.filter.realEstateVersion = "V2";
                this.filter.source = 'INSIDE'

                this.$http.post('admin/new-real-estate/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            deletedRealEstate(id) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('messages.realEstate.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                    // cancelButtonColor: '#dd3333'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('admin/new-real-estate/' + id)
                            .then((res) => {
                                if (res && res.data && res.data.status === 'SUCCESS') {
                                    this.$swal({
                                        title: this.$t('messages.common.success'),
                                        text: this.$t('messages.realEstate.deleteSuccess'),
                                        type: 'success'
                                    });
                                    this.initList();
                                } else {
                                    this.$swal({
                                        title: this.$t('messages.common.warning'),
                                        text: res.data.message,
                                        type: 'warning'
                                    });
                                }
                                this.processing = false;
                            }, () => {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.realEstate.deleteError'),
                                    type: 'error'
                                });
                                this.processing = false;
                            });
                    }
                });
            },
            onChangeStatus() {
                this.filter.page.page = 1;
                this.initList()
            },
            getGoalType(type) {
                const goals = this.goalTypes.filter((t) => t.key === type);
                return goals.length > 0 ? goals[0].name : '';
            },
            calculateCoordination(result) {
                const coordination = result.coordination;
                coordination.expense.total = (coordination.approachCost ? (result.coordination.expense.amount * result.coordination.expense.factorAverage) : 0);
                coordination.comparison.total = (coordination.approachComparative ? (result.coordination.comparison.amount * result.coordination.comparison.factorAverage) : 0);
                coordination.income.total = (coordination.approachIncome ? (result.coordination.income.amount * result.coordination.income.factorAverage) : 0);
                coordination.total = coordination.expense.total + coordination.comparison.total + coordination.income.total;

                return coordination;
            },
            viewRealEstateAct(id) {
                this.$eventBus.$emit('showBuildingActModal',id);
            },
            viewRealEstateSurvey(realEstate) {
                this.$eventBus.$emit('showBuildingSurveyModal', realEstate)
            },
            handleChangeLand(e, result) {
                const realEstate = result;
                const name = e.target.name;
                if (realEstate[name]) {
                    Object.keys(realEstate).map((key) => {
                        if (key !== name) {
                            if (key === 'landComparisonEnabled' || key === 'landLeaseEnabled') {
                                realEstate[key] = false;
                            }
                        }
                    })
                }

                this.loading = true;
                this.$http.post('admin/new-real-estate/land-enabled/change', realEstate)
                    .then(res => {
                        this.loading = false;
                        if (res.data.status === "ERROR") {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: res.data.message,
                                type: 'warning'
                            });
                            return;
                        }
                        this.$router.go(0);
                    });
            },
            getCoordination(id) {
                return this.$http.get('admin/new-real-estate/coordination/' + id);
            },
            changeStatus(status, realEstate) {
                if (status === 'Evaluated') {
                    this.loadEspAppraiser = true;

                    this.getCoordination(realEstate.id).then((res) => {
                        const coordination = res.data.coordination;
                        let errorTxt = '';
                        if (realEstate.approachCost && coordination.expense.amount === 0) {
                            errorTxt = "Харажат"
                        }
                        if (realEstate.approachIncome && coordination.income.amount === 0) {
                            if (errorTxt.length > 0) errorTxt += ', ';
                            errorTxt += "Даромад"
                        }
                        if (realEstate.approachComparative && coordination.comparison.amount === 0) {
                            if (errorTxt.length > 0) errorTxt += ', ';
                            errorTxt += "Киёсий"
                        }

                        if (errorTxt.length > 0) {
                            errorTxt += " хисоб-китоб килинмаган!";
                            this.$swal({
                                title: this.$root.$t('messages.common.warning'),
                                text: errorTxt,
                                type: 'warning'
                            });
                        } else this.$router.push({ path: '/new-real-estate/coordination/' + realEstate.id + '/' + true, query: {isEdit: false}});
                    });

                    this.loadEspAppraiser = false;

                } else if (status === 'Confirmed') {
                    this.changeStatusGo(status, realEstate);
                }
            },
            changeStatusGo(status, realEstate) {
                this.loadEspDirector = true;
                this.$http.post('admin/new-real-estate/status', {
                    realEstateId: realEstate.id,
                    status: status,
                }).then(res => {
                    if (res && res.data && res.data.status === 'SUCCESS') {
                        this.$swal({
                            title: this.$root.$t('messages.common.success'),
                            text: this.$root.$t('messages.realEstate.statusSuccess'),
                            type: 'success'
                        });
                        if (status === 'Confirmed' && realEstate.hasEsp && realEstate.appraiserReportEsp) {
                            this.showDirectorEsp(realEstate.id)
                        }
                    } else {
                        this.$swal({
                            title: this.$root.$t('messages.common.warning'),
                            text: this.$root.$t('messages.realEstate.statusWarning'),
                            type: 'warning'
                        });
                    }
                    this.loadEspDirector = false;
                }, () => {
                    this.$swal({
                        title: this.$root.$t('messages.common.error'),
                        text: this.$root.$t('messages.realEstate.statusError'),
                        type: 'error'
                    });
                    this.loadEspDirector = false;
                });
            },
            // showAppraiserEsp(realEstateId) {
            //     this.$eventBus.$emit('showRealEstateAppraiserEspModal',realEstateId)
            // },
            showDirectorEsp(realEstateId) {
                this.$http.get(`esign/director/${realEstateId}/Building`)
                    .then(res => {
                        if (res.data && res.data.status === 'SUCCESS') {
                            window.open(res.data.data, '_blank');
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: res.data.message,
                                type: 'warning'
                            });
                        }
                    }, err => {
                        console.log(err);
                    })
            },
            canSave(realEstate) {
                return (realEstate.status === 'Pending' || realEstate.status === 'AssignedToEvaluator' || realEstate.status === 'NotFullyEvaluated');
            },
            onProvinceFocus() {
              // this.provinces = [];
              if (!this.provinces.length) {
                  this.filterProvince.search = '';
                  this.$http.post('/province/list', this.filterProvince)
                      .then(res => {
                          this.provinces = res.data.data;
                      }, err => {
                          console.log(err);
                      });
              }
            },
            onProvinceSearch(searchTxt, loading) {
                loading(true);
                this.provinces = [];
                this.filterProvince.search = searchTxt;
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionSearch(searchTxt, loading) {
                loading(true);
                this.regions = [];
                this.filterRegion.search = searchTxt;
                this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionFocus() {
              // this.regions = [];
              if (!this.regions.length) {
                  this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
                  this.$http.post('/region/search', this.filterRegion)
                      .then(res => {
                          this.regions = res.data.data;
                      }, err => {
                          console.log(err);
                      });
              }
            },
            onChangeFilterProvince() {
                if (this.regions.length) this.regions = [];
                if (this.region) this.region = null
                this.filter.region = null
                this.filter.province = null

                if (this.province) {
                    this.filter.province = this.province.code
                }

                this.initList();
            },
            onChangeFilterRegion() {
                if (this.region) {
                    this.filter.region = this.region.code
                    this.initList();
                }
            }
        },
        watch:{
            $route (to, from){
                console.log(to);
                console.log(from);
                this.initList();
            }
        },
        created() {
            this.filterProvince.page.size = 1000;
            this.filterRegion.page.size = 1000;
            this.initList();
        }
    }
</script>

<style scoped>
    .table .form-check .form-check-sign, .table .form-check .form-check-sign:before, .table .form-check .form-check-sign:after {
        margin-top: 0;
    }
</style>
